import React, { useState } from 'react'
import { Button, Input } from 'antd'

import { useDispatch, useSelector } from 'react-redux'
import { authslice } from '../store/auth/authSlice'
import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'

function Home() {
  const { logout } = authslice.actions
  const dispatch = useDispatch()
  const auth = useSelector((state) => state.auth)

  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmNewPassword: '',
  })
  const [loading, setLoading] = useState(false)

  const update = async (dontShowAlert) => {
    try {
      const payload = {
        ...form,
      }
      console.log(payload)

      if (!form.oldPassword || !form.newPassword || !form.confirmNewPassword) {
        return
      }

      if (form.newPassword !== form.confirmNewPassword) {
        alert(`Password didn't matched`)
        return
      }

      setLoading(true)

      const response = await axiosInstance.put(`/api/v1/admin/updatePassword`, payload)
      console.log(response.data)

      setLoading(false)

      if (!dontShowAlert) {
        alert('Password updated successfully ✅')
      }
    } catch (e) {
      console.log(e)
      setLoading(false)

      alert('Failed to update password ❌')
    }
  }

  return (
    <Layout>
      <div>
        <h1>Welcome {auth.user.email}</h1>
        <p>User type: {auth.user.type}</p>
        <p>User verified: {JSON.stringify(auth.user.emailVerified)}</p>

        <div style={{ marginTop: 20, maxWidth: 300 }}>
          <Input.Password placeholder="Old Password" value={form.oldPassword} onChange={(e) => setForm({ ...form, oldPassword: e.target.value })} style={{ marginBottom: 10 }} />

          <Input.Password placeholder="New Password" value={form.newPassword} onChange={(e) => setForm({ ...form, newPassword: e.target.value })} style={{ marginBottom: 10 }} />

          <Input.Password
            placeholder="Confirm New Password"
            value={form.confirmNewPassword}
            onChange={(e) => setForm({ ...form, confirmNewPassword: e.target.value })}
            style={{ marginBottom: 10 }}
          />

          <Button type="primary" loading={loading} onClick={() => update()} style={{ width: '100%' }}>
            Update Password
          </Button>
        </div>

        <Button
          danger
          type="primary"
          onClick={() => {
            dispatch(logout())
          }}
          style={{ marginTop: 20 }}
        >
          Logout
        </Button>
      </div>
    </Layout>
  )
}

export default Home
